import { render, staticRenderFns } from "./TableHeaderButtons.vue?vue&type=template&id=7beb9612&scoped=true&"
import script from "./TableHeaderButtons.vue?vue&type=script&lang=ts&"
export * from "./TableHeaderButtons.vue?vue&type=script&lang=ts&"
import style0 from "./TableHeaderButtons.vue?vue&type=style&index=0&id=7beb9612&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7beb9612",
  null
  
)

export default component.exports